"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  exportCostSlipUpload: {
    confirm: '确定',
    pleaseCheckData: '请勾选数据',
    vvl: 'VVL',
    sailingDate: '开航时间',
    toDate: '到',
    bkNo: '订舱号',
    blNo: '提单号',
    feeState: '费用状态',
    bankSlipState: '水单状态',
    applyInvoiceState: '开票申请状态',
    pol: '装货港',
    pod: '卸货港',
    tips: ' CNTAO港口仅开放电放保函预览功能，如有问题，请联系对应口岸公司相关人员。',
    timeFrame: '时间范围最大不能超过31天',
    cnshkEmploy: '仅限蛇口（深圳）使用',
    invoiceNo: '开票抬头',
    InvoiceCurrency: '开票币种',
    cnyUsdBillingSeparately: 'CNY/USD分别开票',
    onlyCNY: '只开人民币',
    invoiceWay: '开票方式',
    paper: '纸质开票',
    electronics: '电子发票',
    soaNo: '对账单号',
    invoiceNumber: '发票号',
    polNotNull: '装货港不能为空',
    taxpayerIdentificationNumber: '纳税人识别号',
    address: '客户地址',
    phone: '联系方式',
    bank: '开户银行',
    account: '银行账号',
    consignee: '发票接收邮箱',
    bankUsd: '开户银行(USD)',
    accountUsd: '银行账号(USD)',
    remark: '备注',
    taxpayerIdentificationNumberNotNull: '纳税人识别号不能为空',
    addressNotNull: '客户地址不能为空',
    phoneNotNull: '联系方式不能为空',
    bankNotNull: '开户银行不能为空',
    accountNotNull: '银行账号不能为空',
    consigneeNotNull: '发票接收邮箱不能为空',
    invalidEmail: '发票接收邮箱格式错误',
    invoiceStateValidate: '开票申请空、拒绝时才能进行开票申请',
    invoiceStateValidate1: '请选择未开票的申请数据。',
    amount: '金额',
    cnshkAndCncanValidate: '装货港为CNCAN/CNSHK，请在“水单上传/开票申请”操作',
    costStatusDetermination: '费用状态为空或者已确认',
    costStatusChange: '费用状态变更成功',
    onlyCnshkUse: '仅限蛇口（深圳）使用',
    blNoFeesStateValidate: '存在无提单号或者费用未确认数据，请重新选择',
    paymentStatusValidate: '已付款，无需再上传水单',
    invoiceStateAcceptValidate: '该单号已申请开票并接受，上传水单请点击 “已开票补传水单”。<br/>如已上传水单，请等待我司机器人销账并关注电放情况即可。',
    bankSlipNotArrive: '请选择水单未到账的数据',
    saveSuccessfully: '保存成功',
    payeeContactShipping: "如需用其他抬头付款，请先联系船公司。",
    specialPaymentContact: "如需非以上方式的其他方式付款，请邮件联系船公司特殊处理。",
    updateInvoiceInfo: '如贵司开票资料有更新，请提供给SO附件显示的联系邮箱地址。',
    onlyElectronicInvoice: '我司只能开具电子发票',
    updateEmailForInvoice: '如接收电子发票邮箱有更新，请联系SO附件上的客服邮箱',
    bankSlipUploadInstructions: "水单上传说明:",
    uploadInstructions: '请上传正确水单文件，同时为提高放单效率，银行水单上传格式将限制为PDF/JPG/PNG/BMP/TIFF，除上述文件格式以外内容将限制上传。一次预约多次付款需上传多份文件的用户，烦请合成一份PDF文件，谢谢!',
    noRate: '汇率未完善，请联系管理员！',
    inputVvlOrDataTime: 'Vvl,订舱号,提单号,开航时间不同时为空',
    notUploadFile: '未上传水单附件，请核实是否仅申请开票，仅申请开票最快次日核销！',
    noSecondOpr: '不允许二次操作',
    CNTAODisable: '港口青岛未开放此功能。'
  },
  exportCostSlipUploadTable: {
    amount: '费用清单金额',
    feeState: '费用状态',
    bankSlipState: '水单状态',
    paymentStatus: '付款状态',
    applyInvoiceState: '开票申请状态',
    bkNo: '订舱号',
    blNo: '提单号',
    vesselCode: '船舶代码',
    voyageNo: '航次',
    voyageLeg: '航段',
    pol: '装货港',
    etdOrg: '预计离港',
    pod: '卸货港',
    eta: 'ETA',
    etd: '开航时间',
    del: '目的港',
    auditRemark: '水单审核备注',
    auditRemark2: '发票审核备注'
  }
};